import { Component } from '@angular/core';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss', '../management.shared.scss'],
    standalone: false
})
export class UsersComponent {

}
